import { Container } from 'pixi.js-legacy';

import PriceLine from './pixi-price-line';
import TextValue from './pixi-text-value';

export default class Divider extends Container {
  private label: TextValue;

  private line: PriceLine;

  private pl = 6; // 6px left padding /gap between text and line start

  private getFormattedNumber: (value: number, isMarketPrecision?: boolean) => string;

  constructor({ fontName, sideHeight, getFormattedNumber }: { fontName: string; sideHeight: number; getFormattedNumber: (value: number, isMarketPrecision?: boolean) => string }) {
    super();
    this.getFormattedNumber = getFormattedNumber;

    this.x = 6;
    this.y = sideHeight;

    this.label = new TextValue({ fontName, text: '' });
    this.label.y = -(this.label.textHeight / 2);

    this.line = new PriceLine({ lineX: 0, lineY: 0 });

    this.addChild(this.label, this.line);
  }

  public update(lastMatchedPrice: number): void {
    this.label.text = lastMatchedPrice ? `${this.getFormattedNumber(lastMatchedPrice)}` : 'N/A';
    this.line.x = this.label.textWidth + this.pl;
  }
}
